"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioGroup = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Text = require("../Text/Text");
var _RadioGroupModule = _interopRequireDefault(require("./RadioGroup.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Note:
 * Do not wrap Radio in a label. For simplicity's sake, Radio uses an
 * internal label tag to handle click delegation to the hidden input, and
 * nesting labels is a bad idea.
 */
const RadioGroup = exports.RadioGroup = /*#__PURE__*/React.forwardRef((_ref, forwardRef) => {
  let {
    align = 'vertical',
    name,
    value,
    onChange,
    children,
    classNames,
    error = false,
    errorText = ''
  } = _ref;
  const onChangeHandler = value => {
    if (onChange) {
      onChange(value);
    }
  };
  const childrenWithProps = React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child)) {
      return /*#__PURE__*/React.cloneElement(child, {
        name,
        selectedValue: value,
        onChange: onChangeHandler,
        align,
        error
      });
    }
    return child;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_RadioGroupModule.default.radioGroupContainer, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)({
      [_RadioGroupModule.default.vertical]: align === 'vertical',
      [_RadioGroupModule.default.horizontal]: align === 'horizontal-fixed',
      [_RadioGroupModule.default.horizontalFluid]: align === 'horizontal-fluid'
    }, classNames?.radioGroup),
    ref: forwardRef
  }, childrenWithProps), error && /*#__PURE__*/React.createElement(_Text.BodySmall, {
    color: "danger",
    className: classNames?.errorText
  }, errorText));
});